module.exports = __webpack_public_path__ + "img/instagram.29806fd7.svg";